<template>
  <div class="store-customer-brand-container">
    <el-tag
        size="mini"
        style="margin-right: 8px;"
        :key="tag"
        v-for="(tag) in brands"
        :disable-transitions="false"
        closable
        @close="handleClose(tag)">
      {{ tag }}
    </el-tag>
    <brand-select v-if="isAdding" @add="eventAdd" style="width: 110px;"/>
    <el-button v-else class="button-new-tag" size="mini" @click="handelAdd">添加新品牌</el-button>
  </div>
</template>

<script>
import BrandSelect from "@/components/brand/select.vue"

export default {
  name: "StoreCustomerBrands",
  components: {BrandSelect},
  props: {
    propBrands: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      brands: [],
      isAdding: false
    }
  },
  watch: {
    propBrands: function () {
      this.initBrands()
    }
  },
  mounted() {
    this.initBrands()
  },
  methods: {
    initBrands() {
      this.brands = this.propBrands
    },
    eventAdd(v) {
      this.isAdding = false
      this.brands.push(v)
    },
    handelAdd() {
      this.isAdding = true
    },
    handleClose(v) {
      this.brands.splice(this.brands.indexOf(v), 1)
    }
  }
}
</script>

<style lang="scss">
.store-customer-brand-container {
  .el-tag--mini {
    height: 28px !important;
    line-height: 27px !important;
  }
}
</style>